import NoIcon from 'assets/svg/noCoinIcon.svg?url';

export const onErrorCoinLogo = (event: Event) => {
	(event.target as HTMLImageElement).src = NoIcon;
	(event.target as HTMLImageElement).srcset = '';
};
